var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiv4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 68,
    viewBox: "0 0 69 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.664062,
    width: 68,
    height: 68,
    rx: 20,
    fill: "#06BA63"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.84992
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.3591 19.5041C46.8625 16.492 43.4934 14.3207 39.7118 13.2865C35.9303 12.2524 31.9204 12.4058 28.2295 13.7259C24.5388 15.046 21.3469 17.4684 19.0896 20.6624C16.8323 23.8565 15.6197 27.6666 15.6172 31.5726V36.7547",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 4.92496,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6797 47.7598C24.2978 50.5231 27.6886 52.4399 31.4128 53.2621C35.1371 54.0842 39.0234 53.7738 42.5684 52.371C46.1135 50.9682 49.1542 48.5377 51.2968 45.3942C53.4393 42.2505 54.5852 38.5387 54.5857 34.7392V31.2891",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 4.92496,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2412 28.2634C24.2303 28.4711 24.1614 28.6729 24.0386 28.8481L15.9674 40.237C15.7448 40.5498 15.3783 40.7286 14.9939 40.7086C14.6094 40.6885 14.2637 40.4725 14.0751 40.1382L7.24334 27.9714C7.04533 27.6173 7.05472 27.1832 7.27155 26.8389C7.48698 26.4929 7.87252 26.2928 8.27929 26.314L23.1822 27.092C23.589 27.1132 23.9515 27.3523 24.1294 27.7188C24.2144 27.8915 24.2509 28.0794 24.2412 28.2634Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5163 38.6332C45.5235 38.4279 45.588 38.2277 45.706 38.0528L53.4722 26.6779C53.6865 26.3655 54.045 26.1828 54.4246 26.196C54.8043 26.2092 55.1491 26.4163 55.3409 26.7428L62.2916 38.6296C62.4931 38.9757 62.4913 39.4041 62.2833 39.7476C62.0768 40.0925 61.6999 40.2966 61.2982 40.2826L46.5813 39.7707C46.1797 39.7568 45.8179 39.5269 45.636 39.1685C45.5491 38.9997 45.5099 38.8149 45.5163 38.6332Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiv4);
export default __webpack_public_path__ + "static/media/div4.ac6fbb8d5d0cd0a5d9bc9d774c163d27.svg";
export { ForwardRef as ReactComponent };